import React, { useRef } from "react";
import {
  Box,
  Typography,
  Button,
  TextField,
  FormHelperText,
  Paper,
  useTheme,
} from "@material-ui/core";
import Axios from "axios";
import Notify from "src/notification/Notify";
import * as Yup from "yup";
import { Formik } from "formik";
import CheckIcon from "@material-ui/icons/CheckCircleOutline";
import ClearIcon from "@material-ui/icons/HighlightOff";
import Select from "react-select";
import PsychologyOrder from "src/utils/PsychologyOrder";
import { UsersData } from "src/ContextAPI";

const CreatePsychologyOrder = ({ getPsychologyOrderList }) => {
  const theme = useTheme();
  const { users } = React.useContext(UsersData);
  const orderRef = useRef(null);

  const getFormData = (object) => {
    const formData = new FormData();

    Object.keys(object).forEach((key) => formData.append(key, object[key]));
    return formData;
  };

  const filetedOrder = (department) => {
    const orderlist = PsychologyOrder.list();

    let test = orderlist.filter((data) => {
      return data.department === department;
    });

    return test;
  };

  return (
    <Box component={Paper} p={2}>
      <Box>
        <Typography variant="h6" color="textSecondary">
          Create Order
        </Typography>
      </Box>
      <Box>
        <Formik
          initialValues={{
            username: users.username,
            management_id: users.management_id,
            user_id: users.user_id,
            test: "",
            dept: "psychology",
            rate: "",
            password: "",
          }}
          validationSchema={Yup.object().shape({
            test: Yup.string().required(),
            password: Yup.string().required(),
            dept: Yup.string().required(),
            rate: Yup.number().min(1).required(),
          })}
          onSubmit={async (
            values,
            { setErrors, setStatus, setSubmitting, resetForm }
          ) => {
            try {
              const request = await Axios.post(
                "accounting/items/psycorder/create-order",
                getFormData(values)
              );
              if (request.data.message === "test-exist") {
                Notify.customToast(
                  "Test existed.",
                  " Test already existed in this branch"
                );
              }
              if (request.data.message === "pass-invalid") {
                setErrors({ password: "Password is invalid." });
              }
              if (request.data.message === "success") {
                Notify.successRequest("new test");
                resetForm();
                setSubmitting(true);
                getPsychologyOrderList();
              }
            } catch (error) {
              const message = error.message || "Something went wrong";
              setErrors({ submit: message });
              setSubmitting(false);
            }
          }}
        >
          {({
            errors,
            handleBlur,
            handleChange,
            handleSubmit,
            isSubmitting,
            setFieldValue,
            touched,
            resetForm,
            values,
          }) => (
            <form noValidate onSubmit={handleSubmit}>
              <Box my={2} className={`labselect`}>
                <TextField
                  error={Boolean(touched.dept && errors.dept)}
                  helperText={touched.dept && errors.dept}
                  onBlur={handleBlur}
                  onChange={handleChange}
                  value={values.dept}
                  fullWidth
                  required
                  name="dept"
                  label="Department"
                  variant="outlined"
                  InputProps={{
                    readOnly: true,
                  }}
                />
              </Box>

              <Box my={2} className={`labselect`}>
                <Select
                  options={filetedOrder(values.dept)}
                  ref={orderRef}
                  onChange={(data) => setFieldValue("test", data.value)}
                  styles={{
                    menu: (provided) => ({
                      ...provided,
                      zIndex: 99999,
                      color: "#000",
                    }),
                    control: (base) => ({
                      ...base,
                      minHeight: 55,
                      backgroundColor: "transparent",
                    }),
                    singleValue: () => ({
                      color: theme.palette.type === "dark" ? "#fff" : "#000",
                    }),
                  }}
                />
                {touched.test && errors.test && (
                  <FormHelperText error> {errors.test} </FormHelperText>
                )}
              </Box>

              <Box mb={2} className={`labselect2`}>
                <TextField
                  error={Boolean(touched.rate && errors.rate)}
                  helperText={touched.rate && errors.rate}
                  onBlur={handleBlur}
                  onChange={handleChange}
                  value={values.rate}
                  fullWidth
                  required
                  name="rate"
                  label="Order Rate"
                  variant="outlined"
                  type="number"
                  InputProps={{
                    inputProps: {
                      min: 1,
                      max: 10000,
                      step: 0.01,
                    },
                  }}
                />
              </Box>

              <Box mb={2}>
                <TextField
                  fullWidth
                  required
                  error={Boolean(touched.password && errors.password)}
                  helperText={touched.password && errors.password}
                  onBlur={handleBlur}
                  onChange={handleChange}
                  value={values.password}
                  name="password"
                  label="Enter your password"
                  variant="outlined"
                  type="password"
                />
              </Box>

              {errors.submit && (
                <Box mt={3}>
                  <FormHelperText error>{errors.submit}</FormHelperText>
                </Box>
              )}

              <Box my={2} display="flex">
                <Box mr={2}>
                  <Button
                    type="submit"
                    size="large"
                    variant="contained"
                    color="primary"
                    startIcon={<CheckIcon />}
                    disabled={isSubmitting}
                  >
                    Save
                  </Button>
                </Box>
                <Box>
                  <Button
                    variant="contained"
                    color="default"
                    size="large"
                    onClick={resetForm}
                    startIcon={<ClearIcon />}
                  >
                    Clear
                  </Button>
                </Box>
              </Box>
            </form>
          )}
        </Formik>
      </Box>
    </Box>
  );
};

export default CreatePsychologyOrder;
